import React, { useState } from 'react';

const DoneWithConditionModal = ({ onClose, onConfirm }) => {
    const [note, setNote] = useState('');
    return (
        <div className="return-modal-overlay" onClick={onClose}>
            <div className="return-modal" onClick={(e) => e.stopPropagation()}>
                <h2 className="return-modal__title">ทำการ Done with condition</h2>
                <div className="return-modal__field">
                    <label className="return-modal__label">หมายเหตุ</label>
                    <textarea
                        className="return-modal__textarea"
                        placeholder="Type your message here"
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        rows={4}
                    />
                </div>
                <div className="return-modal__footer">
                    <button className="return-modal__btn return-modal__btn--cancel" onClick={onClose}>Cancel</button>
                    <button
                        className="return-modal__btn return-modal__btn--submit"
                        onClick={() => onConfirm(note)}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DoneWithConditionModal;